/**
 * Guest boot entry — import this first from main.ts.
 *
 * Side effects on evaluation:
 *  1. Resolve GUEST_MODE from the pathname.
 *  2. Install fail-closed egress guards (fetch / XHR / default axios).
 *
 * Other axios instances (httpClient, publicClient) register their own
 * guards when those modules load, via registerGuestAxiosGuard.
 */
import { GUEST_MODE } from '@/guest/guestMode'
import { installEgressGuard } from '@/guest/egressGuard'

if (GUEST_MODE) {
    installEgressGuard()
}

export { GUEST_MODE, isGuestMode, isGuestStrictMode } from '@/guest/guestMode'
